import colors from "./colors";
import components from "./components";

export default {
    colors,
    components,
    primaryShade: { light: 5, dark: 5 },
};
